import React from 'react';
import Main from './components/Main';
import './index.scss';

const TakeoutPage = () => {
    return (
        <div>
            <Main />
        </div>
    )
}
export default TakeoutPage
